import { getTranslateNsT } from "@/utils/getTranslateNsT";

export function getMemberLevelTranslate(level: number) {
  const t = getTranslateNsT("profile");
  return t(`member-system-${level}`);
}
